import { connect } from 'react-redux'
import WalletPane from '../../../components/riders/editrider/wallet/WalletPane'
import {
  getRiderWallet,
  addRiderPaymentSource,
  updateDefaultPaymentSource,
  removeRiderPaymentSource
} from '../../../state/actions/riders'
import { IStoreState } from '../../../types'

export function mapStateToProps(state: IStoreState, ownProps: any): any {
  return {
    rider: ownProps.rider,
    metadata: state.riders.metadata
  }
}

export function mapDispatchToProps(dispatch: any) {
  return {
    getRiderWallet: (riderId: string) => {
      return dispatch(getRiderWallet(riderId))
    },
    addRiderPaymentSource: (stripeToken: string, riderId: string) => {
      return dispatch(addRiderPaymentSource(stripeToken, riderId))
    },
    updateDefaultPaymentSource: (paymentSourceId: string, riderId: string) => {
      return dispatch(updateDefaultPaymentSource(paymentSourceId, riderId))
    },
    removeRiderPaymentSource: (paymentSourceId: string, riderId: string) => {
      return dispatch(removeRiderPaymentSource(paymentSourceId, riderId))
    }
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(WalletPane)



// WEBPACK FOOTER //
// ./src/containers/riders/editrider/WalletPane.ts